(function () {
  var script = document.querySelector('[data-fn-browser-compat]');
  if (!script) return;
  var timers = new WeakMap();

  function fallbackCopy(code) {
    var active = document.activeElement;
    var field = document.createElement('textarea');
    field.value = code;
    field.readOnly = true;
    field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px';
    document.body.appendChild(field);
    var copied = false;
    try {
      field.focus({ preventScroll: true });
      field.select();
      field.setSelectionRange(0, code.length);
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    } finally {
      field.remove();
      if (active instanceof HTMLElement) active.focus({ preventScroll: true });
    }
    return copied;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('[data-fn-copy], [data-fn-fr-copy]');
    if (!button || button.dataset.fnCopyBusy === 'true') return;
    var label = button.querySelector('span');
    if (!label) return;
    var code = button.getAttribute('data-fn-copy') || button.getAttribute('data-fn-fr-copy');
    if (!code) return;
    button.dataset.fnCopyBusy = 'true';
    clearTimeout(timers.get(button));
    var status = button.nextElementSibling;
    if (!status || !status.hasAttribute('data-fn-copy-status')) {
      status = document.createElement('span');
      status.setAttribute('data-fn-copy-status', '');
      status.setAttribute('role', 'status');
      status.style.cssText = 'display:block;font-size:12px;white-space:normal';
      button.insertAdjacentElement('afterend', status);
    }
    status.textContent = '';
    function finish(copied) {
      delete button.dataset.fnCopyBusy;
      button.classList.toggle('is-copied', copied);
      label.textContent = copied ? script.dataset.copied : code;
      status.textContent = copied ? '' : script.dataset.copyManually;
      if (copied) timers.set(button, setTimeout(function () {
        button.classList.remove('is-copied');
        label.textContent = code;
      }, 1600));
    }
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(code).then(function () { finish(true); }, function () { finish(fallbackCopy(code)); });
      } else {
        finish(fallbackCopy(code));
      }
    } catch (error) {
      finish(fallbackCopy(code));
    }
  });
})();
